var map = {
	"./decidim/avatar-multiuser.png": 9277,
	"./decidim/brands/google.svg": 8960,
	"./decidim/cc-badge.png": 9179,
	"./decidim/decidim-logo.svg": 9935,
	"./decidim/default-avatar.svg": 8099,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 1801,
	"./decidim/icons.svg": 8882,
	"./decidim/pattern.png": 3953,
	"./decidim/placeholder-card-g.svg": 286,
	"./decidim/placeholder-card-l.svg": 3829,
	"./decidim/placeholder.jpg": 8532,
	"./decidim/remixicon.symbol.svg": 806,
	"./decidim/vendor/leaflet/layers-2x.png": 115,
	"./decidim/vendor/leaflet/layers.png": 1178,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 111,
	"./decidim/vendor/leaflet/marker-icon.png": 7446,
	"./decidim/vendor/leaflet/marker-shadow.png": 7869,
	"./decidim/vendor/social-share-button/douban.svg": 9177,
	"./decidim/vendor/social-share-button/email.svg": 5066,
	"./decidim/vendor/social-share-button/facebook.svg": 8818,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 2462,
	"./decidim/vendor/social-share-button/hacker_news.svg": 9418,
	"./decidim/vendor/social-share-button/linkedin.svg": 7608,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 49,
	"./decidim/vendor/social-share-button/pinterest.svg": 3028,
	"./decidim/vendor/social-share-button/reddit.svg": 9662,
	"./decidim/vendor/social-share-button/telegram.svg": 6847,
	"./decidim/vendor/social-share-button/tumblr.svg": 1468,
	"./decidim/vendor/social-share-button/twitter.svg": 6799,
	"./decidim/vendor/social-share-button/vkontakte.svg": 1981,
	"./decidim/vendor/social-share-button/wechat.svg": 6240,
	"./decidim/vendor/social-share-button/whatsapp.svg": 1584,
	"./decidim/vendor/social-share-button/x.svg": 4650,
	"./decidim/vendor/social-share-button/xing.svg": 3374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7096;